import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  Table,
  Tooltip,
  OverlayTrigger,
  Button
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { festivalActions } from '../../../redux/actions/festival-action';
import { baseUrl } from 'helper/ApiCall';
import MessageCom from "layouts/Dashboard/Message";
import BackNavigationButton from "components/ThemeComponents/BackNavigationButton";
var Modal = require('react-bootstrap-modal');

class FestivalAdjudicatorListPage extends Component{
  constructor(props){
    super(props);
    let AdminUserStorage = JSON.parse(localStorage.getItem('admin-user'));
    const { festivalId } = this.props.match.params;
    this.state = {
      festivalId : festivalId,
      submitted   : false,
      Title : 'Adjudicator list',
      addModalUser: false,
      addModalUserEdit: false,
      user:{ first_name:'', email: '', last_name:'' },
      editAdjudicator:'',
      userError : {
        first_nameError:'',
        emailError:'',
        last_nameError:'',
      },
      adjudicators:{},
      AdminUserStorageToken : AdminUserStorage.token
    };
    this.openModalUser = this.openModalUser.bind(this);
    this.closeModalUser = this.closeModalUser.bind(this);
    this.saveAndCloseUser = this.saveAndCloseUser.bind(this);

    this.openModalUserEdit = this.openModalUserEdit.bind(this);
    this.closeModalUserEdit = this.closeModalUserEdit.bind(this);
    this.saveAndCloseUserEdit = this.saveAndCloseUserEdit.bind(this);


    this.handleUser = this.handleUser.bind(this);
    this.handleUserEdit = this.handleUserEdit.bind(this);
    this.handleUserSubmit = this.handleUserSubmit.bind(this);
    this.handleUserEditSubmit = this.handleUserEditSubmit.bind(this);
    this.validateAdd = this.validateAdd.bind(this);
    this.validateEdit = this.validateEdit.bind(this);

    this.clearField = this.clearField.bind(this);
    this.printAdjudicator = this.printAdjudicator.bind(this);
    this.deleteFestivalAdjudicator = this.deleteFestivalAdjudicator.bind(this);
    this.deleteFestivalConfirmAdjudicator = this.deleteFestivalConfirmAdjudicator.bind(this);
  };
  
  printAdjudicator(festivalId) {
    console.log('festivalId', festivalId);
  }
  deleteFestivalAdjudicator(festivalId, userId){
    const { dispatch } = this.props;
    dispatch(festivalActions.deleteFestivalAdjudicator(festivalId, userId));

  }

  deleteFestivalConfirmAdjudicator(festivalId, userId){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Festival Adjudicator</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the festival adjudicator?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteFestivalAdjudicator(festivalId, userId)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  randomString(len, charSet) {
      // charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      charSet = charSet || 'ABCDEFGHIJKMNOPQRSTUVWXYZ023456788';
      var randomString = '';
      for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length);
          randomString += charSet.substring(randomPoz,randomPoz+1);
      }
      return randomString;
  }
  clearField(){
    this.setState({user:{first_name:'', email:'', last_name:''}});
    this.setState({userError:{first_nameError:'', emailError:'', last_nameError:''}});
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(festivalActions.getFestivalAdjudicators(this.state.festivalId));
  }

  handleUserEditSubmit(e){
    e.preventDefault();
    this.setState({ submitted: true }, function(){
      const err = this.validateEdit();
      if (!err){

        console.log('this.props.editAdjudicator', this.props.editAdjudicator);
        const { dispatch } = this.props;
        dispatch(festivalActions.editFestivalAdjudicator(this.state.editAdjudicator, this.state.festivalId, this.props.editAdjudicator.id));
      }
    });
  }
  handleUser(e){
    const { name, value } = e.target;
    const userState = {...this.state.user};
    userState[name] = value;
    this.setState({user: userState}, function(){

    });
  }

  handleUserEdit(e){
    const { name, value } = e.target;
    const userStateEdit = {...this.state.editAdjudicator};
    userStateEdit[name] = value;
    this.setState({editAdjudicator: userStateEdit}, function(){

    });
  }
  
  validateEdit(){
    let   isError = false;
    const errors = {
      first_nameError:'',
      emailError:'',
      last_nameError:'',
    };

    if (this.state.editAdjudicator.first_name.length === 0 || this.state.editAdjudicator.first_name.trim() === '') {
        isError = true;
        errors.first_nameError = "First Name is required.";
    }
    if ( this.state.editAdjudicator.email !== '' && this.state.editAdjudicator.email !==null ) {
      if (!(this.state.editAdjudicator.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ) {
          isError = true;
          errors.emailError = "Email must be abc@example.com format.";
      }
    }

    if ((this.state.editAdjudicator.last_name.length === 0 || this.state.editAdjudicator.last_name === '') ) {
        isError = true;
        errors.last_nameError = "Last Name is required.";
    }

    this.setState({userError: errors}, function(){
      // console.log('user validation',this.state.userError);
    });
    return isError; 
  }
  validateAdd(){
    let   isError = false;
    const errors = {
      first_nameError:'',
      emailError:'',
      last_nameError:'',
    };

    if (this.state.user.first_name.length === 0 || this.state.user.first_name.trim() === '') {
        isError = true;
        errors.first_nameError = "First Name is required.";
    }
    // console.log('email add', this.state.editAdjudicator);
    if ( this.state.user.email !== '' ) {
      if ( !(this.state.user.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ) {
          isError = true;
          errors.emailError = "Email must be abc@example.com format.";
      }
    }
    
    if ((this.state.user.last_name.length === 0 || this.state.user.last_name.trim() === '') ) {
        isError = true;
        errors.last_nameError = "Last Name is required.";
    }

    this.setState({userError: errors}, function(){
      // console.log('user validation',this.state.userError);
    });
    return isError; 
  }
  handleUserSubmit(e){
    e.preventDefault();
    this.setState({ submitted: true }, function(){
      const err = this.validateAdd();
      if (!err){
        const { dispatch } = this.props;
        dispatch(festivalActions.storeFestivalAdjudicator(this.state.user, this.state.festivalId));
      }
    });
  }
  closeModalUser(){
    this.clearField();
    this.setState({addModalUser:false});
  }
  saveAndCloseUser(){
    this.clearField();
    this.setState({addModalUser:false});
  }
  openModalUser(){
    this.clearField();
    this.setState({addModalUser:true});
  }

  closeModalUserEdit(){
    this.clearField();
    this.setState({addModalUserEdit:false});
  }
  saveAndCloseUserEdit(){
    this.clearField();
    this.setState({addModalUserEdit:false});
  }
  openModalUserEdit(id){
    this.clearField();
    const { dispatch } = this.props;
    dispatch(festivalActions.getFestivalAdjudicator(id));
    
  }

  componentWillReceiveProps(nextProps) {

      // console.log('nextProps', nextProps);
      if (nextProps.editAdjudicator && !nextProps.loading && nextProps.editCheck){
        this.setState({editAdjudicator:{
          first_name:nextProps.editAdjudicator.first_name,
          email:nextProps.editAdjudicator.email,
          last_name:nextProps.editAdjudicator.last_name,
        }}, function(){

          this.setState({addModalUserEdit:true});
        });
      }

      if (nextProps.adjudicators){

        this.setState({adjudicators:nextProps.adjudicators});
      }
      
  }
  render(){
      const { user, userError, submitted } = this.state;
      const { adjudicators, adminType, festival  } = this.props;
        return(
          <div className="content">
            <Grid fluid>
                <Row>
                  <Col md={12}>
                      <Card
                        headerTopContent={
                          <div style={{ marginBottom: "10px" }}>
                            <BackNavigationButton
                              defaultPath="Festivals"
                              queryPrefix=""
                              className="btn btn-info btn-sm"
                              title="Back"
                            />
                          </div>
                        }
                        title="Festival Adjudicator List"

                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                              
                              

                              <Row>
                                <Col md={6} className="mb-20-test">
                                  {
                                    festival &&
                                      <h4 style={{'margin':'0px'}}> Festival Name: <strong>{festival.name}</strong></h4>
                                  }
                                </Col>
                                <Col md={6} className="text-right mb-20-test">
                                  <div >
                                    {
                                      adminType ==='company' && 
                                      <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add Adjudicator</Tooltip>}>
                                        <Button type='button' style={{marginRight:'5px'}} className="outOfTableButton btn btn-info" onClick={this.openModalUser} ><i className="fa fa-plus" />Adjudicator</Button>
                                      </OverlayTrigger>
                                    }
                                  </div>
                                </Col>
                              </Row>
                            </Grid>
                            
                            <div>
                            {/*Company Users Table Start*/}
                            { adjudicators && adjudicators.length > 0 &&
                              <Table striped hover className="myTable tableLayoutFix">
                                <thead>
                                  <tr>
                                    <th>First name</th>
                                    <th>Email</th>
                                    <th>Last Name</th>
                                    <th className="action-center">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {adjudicators.map((prop, key) => {
                                    return (
                                      <tr key={key}>
                                        <td>{prop.first_name}</td>
                                        <td>{prop.email}</td>
                                        <td>{prop.last_name}</td>
                                        <td className="action-center">
                                          {/*
                                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit User</Tooltip>}>
                                              <button type='button' className="action-button-size" ><i className="fa fa-pencil" /></button>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete User</Tooltip>}>
                                              <button type='button' className="action-button-size" ><i className="fa fa-trash " /></button>
                                            </OverlayTrigger>
                                          */}
                                          
                                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Adjudicator {adminType ==='company'?'edit':'view'}</Tooltip>}>
                                            <button type='button' className="action-button-size" onClick={() => this.openModalUserEdit(prop.id)}><i className={adminType ==='company'?"fa fa-pencil":"fa fa-eye"} /></button>
                                            </OverlayTrigger>
                                            {
                                              adminType ==='company' && 
                                              <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete Adjudicator</Tooltip>}>
                                                <button type='button' className="action-button-size" onClick={() => this.deleteFestivalConfirmAdjudicator(prop.festival_id, prop.id)}><i className="fa fa-trash " /></button>
                                              </OverlayTrigger>
                                            }
                                            
                                          
                                        </td>
                                      </tr>
                                    );
                                  })}

                                 
                                </tbody>
                              </Table>
                            }
                            </div>
                            {
                              adjudicators && adjudicators.length === 0 &&

                              <Grid fluid>
                                <Row>
                                    <Col md={8}>
                                      <h4>No Adjudicator User Found</h4>
                                    </Col>
                                </Row>
                              </Grid>
                              
                            }
                            
                            {/*Company Users Table End*/}

                            {/* Add User*/}
                            

                            {/*Edit User Modal start*/}
                            { this.state.addModalUserEdit && 
                              <Modal show={this.state.addModalUserEdit} onHide={this.closeModalUserEdit} aria-labelledby="ModalHeader" >
                              <Modal.Header closeButton>
                                <Modal.Title id='ModalHeader'>Adjudicator {adminType ==='company'?'Edit':''}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="row">
                                  <div className="col-md-12">
                                    <form onSubmit={this.handleUserEditSubmit}>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.first_nameError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="first_name">First name</label>
                                            <input type="text" name="first_name" className="form-control"  value={this.state.editAdjudicator.first_name} onChange={this.handleUserEdit} />
                                            {
                                              submitted && userError.first_nameError!=='' &&
                                              <div className="help-block">{userError.first_nameError}</div>
                                            }
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.last_nameError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="last_name">Last Name</label>
                                            <input type="text" name="last_name" className="form-control"  value={this.state.editAdjudicator.last_name} onChange={this.handleUserEdit} readOnly={adminType ==='admin'?true:false}/> {
                                              submitted && userError.last_nameError!=='' &&
                                              <div className="help-block">{userError.last_nameError}</div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className={'form-group' + (submitted && userError.emailError!=='' ? ' has-error' : '')}>
                                            <label htmlFor="email">Email</label>
                                            <input type="text" name="email" className="form-control" value={this.state.editAdjudicator.email?this.state.editAdjudicator.email:''} onChange={this.handleUserEdit} />
                                            {
                                              submitted && userError.emailError!=='' &&
                                              <div className="help-block">{userError.emailError}</div>
                                            }
                                          </div>
                                        </div>
                                      </div>

                                      {
                                        adminType === 'company' &&
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className='btn-toolbar'>
                                              <Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton " >Save</Button>
                                              <Button bsSize="large" bsStyle="info" onClick={()=>this.closeModalUserEdit() } className="outOfTableButton" >Cancel</Button>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      <div className="row">
                                        <div className="col-md-12">
                                          <div>
                                            <MessageCom  />
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                  
                                </div>
                              </Modal.Body>
                              </Modal>
                            }
                            {/*Edit User Modal End*/}

                            {/*Add User Modal Start*/}
                            <Modal show={this.state.addModalUser} onHide={this.closeModalUser} aria-labelledby="ModalHeader" >
                              <Modal.Header closeButton>
                                <Modal.Title id='ModalHeader'>Add Adjudicator</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                              <div className="row">
                                <div className="col-md-12">
                                  <form onSubmit={this.handleUserSubmit}>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.first_nameError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="first_name">First Name</label>
                                          <input type="text" name="first_name" className="form-control"  value={user.first_name} onChange={this.handleUser}/>
                                          {
                                            submitted && userError.first_nameError!=='' &&
                                            <div className="help-block">{userError.first_nameError}</div>
                                          }
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.last_nameError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="last_name">Last Name</label>
                                          <input type="text" name="last_name" className="form-control"  value={user.last_name} onChange={this.handleUser}/>
                                          {
                                            submitted && userError.last_nameError!=='' &&
                                            <div className="help-block">{userError.last_nameError}</div>
                                          }
                                        </div>
                                      </div>


                                    </div>
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className={'form-group' + (submitted && userError.emailError!=='' ? ' has-error' : '')}>
                                          <label htmlFor="email">Email</label>
                                          <input type="text" name="email" className="form-control" value={user.email} onChange={this.handleUser} />
                                          {
                                            submitted && userError.emailError!=='' &&
                                            <div className="help-block">{userError.emailError}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className='btn-toolbar'>
                                          <Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton" >Save</Button>
                                          <Button bsSize="large" bsStyle="info" onClick={()=>this.closeModalUser() } className="outOfTableButton" >Cancel</Button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div>
                                          <MessageCom  />
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                                
                                </div>
                              </Modal.Body>
                            </Modal>
                            {/*Add User Modal End*/}
                          </div>
                        }
                    />
                  </Col>
                </Row>
              </Grid>
          </div>
        );
  }
}


function mapStateToProps(state) {
    const { loading, editAdjudicator, adjudicators, festival, editCheck } = state.festivalReducer;
    
    const { adminType, userAdmin } = state.adminReducer;

    return {
        loading, editAdjudicator, adjudicators, adminType, userAdmin, festival, editCheck
    };
}

const FestivalAdjudicatorList = connect(mapStateToProps)(FestivalAdjudicatorListPage);
export default FestivalAdjudicatorList;


// WEBPACK FOOTER //
// ./src/components/Admin/FestivalAdjudicator/FestivalAdjudicatorList.jsx